import { Model } from "../Components/Models/Model";
import { MenuHouperModel } from "./Menu/MenuHouperModel";
import { MenuItems } from "./Menu/MenuItems";


class MenuController extends Model {
    private _menuHouper: MenuHouperModel
    private _menuItems: MenuItems;
    private _blured: boolean = false;

    constructor(){
        super()
        
        this._menuHouper = new MenuHouperModel()
        this._menuItems = new MenuItems();
    }

    get menuItems(){
        return this._menuItems
    }

    get menuHouper(){
        return this._menuHouper
    }


    page(str:string){
        this.menuItems.page(str)
    }

    setBlured = (bool: boolean) => {
        if(this._blured === bool){
            return
        }
        this._blured = bool
        this.updateMe()
    }

    get blured(){
        return this._blured
    }

    removeSelected(){
        this._menuItems.removeSelected()
    }
}

export { MenuController }